// Vow & Video Essex - mock data

export const SITE = {
  name: "Vow & Video Essex",
  short: "V&V Essex",
  tagline: "Cinematic Wedding Films & Photography in Essex",
  ctaUrl: "https://essex.weddingvideo.co.uk/",
  phone: "01277 280 512",
  email: "alex@weddingvideo.co.uk",
  enquiryEmail: "alex@weddingvideo.co.uk",
  location: "Wickford, Essex",
  address: {
    line1: "Unit 6 Hodgson Court",
    line2: "Hodgson Way",
    line3: "Wickford, Essex, SS11 8XR"
  },
  parentName: "Wedding Video Essex",
  parentUrl: "https://www.weddingvideo.co.uk",
  groupName: "The WVE Group",
  groupUrl: "https://www.wvegroup.co.uk/",
  builtByLabel: "Built by the Wedding Video Essex Team",
  social: {
    instagram: "https://instagram.com/WeddingVideoEssex",
    facebook: "https://facebook.com/WeddingVideoEssex",
    youtube: "https://youtube.com/@WeddingVideoEssex",
    tiktok: "https://tiktok.com/@WeddingVideoEssex"
  }
};

export const HERO = {
  heading_lines: ["WE FILM", "LOVE STORIES"],
  sub: "Cinematic wedding films & photos that catch every laugh, tear and slow dance. Two videographers, every booking. Filming Essex weddings since 2015.",
  videoId: "KTLcIqddWSE",
  poster: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=2400&q=80"
};

export const STATS = [
  { value: "900+", label: "Couples Filmed" },
  { value: "100+", label: "Weddings A Year" },
  { value: "10+",  label: "Years in Essex" },
  { value: "5.0",  label: "Average Rating" },
  { value: "7x",   label: "Award Winners" }
];

export const AWARDS = [
  { name: "Essex Wedding Awards Winner 2026", img: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/t490eo40_essex-wedding-awards-winner-logo-2026.png" },
  { name: "Hitched Wedding Awards 2026",     img: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/6c9sworo_badge-weddingawards_en_GB_edited.png" },
  { name: "Bridebook Platinum 2026",         img: "https://image.bridebook.com/badge/platinum-2026-uk@v1.png" }
];

export const FEATURED_IN = [
  "ITV", "Paramount", "MTV", "The Sun", "Daily Mail", "Hitched", "Bridebook"
];

export const ABOUT = {
  kicker: "Why you'll want us there",
  heading_pre: "The most important guests",
  heading_post: "you'll invite",
  body: [
    "You're inviting a hundred of your favourite people. Invite three more. Us.",
    "We blend in like guests, work quietly in the corners, and make sure none of it slips away. Your vows. Your nan crying through the speeches. Your bridesmaids absolutely losing it on the dancefloor. The way they look at you when you walk in.",
    "In ten years you won't remember half of it. Press play and you'll feel every bit of it again."
  ],
  parent_note: "Brought to you by the team behind",
  image: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/x688lp10_7fcf9bde-226f-46a2-8ad1-72631bf5d44e.jpeg",
  pull_quote: "\u201CThere wasn't a dry eye in the house.\u201D",
  pull_quote_credit: "Tanya + Ellie"
};

export const SERVICES = [
  {
    title: "Wedding Videography",
    sub: "Two videographers. Full day. Proper cinematic film.",
    bullets: [
      "Two videographers on every booking",
      "Full day from bridal prep to first dance",
      "20 to 30 minute cinematic film",
      "3 to 4 minute sneak peek within 72 hours",
      "Full ceremony & speeches (multi-camera)",
      "Drone footage (weather permitting)"
    ],
    image: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/qvohih3a_68bf6f06-bd19-450a-afb2-11eee303d2fa.jpeg"
  },
  {
    title: "Wedding Photography",
    sub: "Documentary style. Editorial eye. Zero awkward poses.",
    bullets: [
      "Full day from prep to first dance",
      "Natural, documentary style",
      "500+ professionally edited photos",
      "Online gallery to share with everyone",
      "Designed to match the style of your film"
    ],
    image: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/ssb395rm_b14a407c-9290-4bb7-b11d-628b1afe5c78.jpeg"
  },
  {
    title: "Photo & Video Together",
    sub: "One team. One style. Everything covered.",
    bullets: [
      "One team that works side by side every weekend",
      "Consistent visual style across photos & film",
      "Better coordination, no missed moments",
      "One supplier, one point of contact",
      "Much better value than booking separately"
    ],
    image: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/1bd4nto7_536a87c3-d217-4dbd-9171-4b424e7bc63c.jpeg"
  }
];

export const FILMS = [
  { id: "KTLcIqddWSE", couple: "Emma & Mark", venue: "Gaynes Park" },
  { id: "tSAyeoBfnOk", couple: "Laura & Scott", venue: "High House, Essex" },
  { id: "TSGJyA-meX8", couple: "Tayla & Danny", venue: "Hatfield Place" },
  { id: "OynwPvMB2i0", couple: "Holly & Marc", venue: "The Boundary" },
  { id: "1DXk4bMe3WM", couple: "Leah & Josh", venue: "Gaynes Park, Essex" },
  { id: "ylVnOyaa76E", couple: "Bianca & Taylor", venue: "Ye Olde Plough House" }
];

export const VENUES = [
  { name: "Gaynes Park",    img: "https://img.youtube.com/vi/KTLcIqddWSE/maxresdefault.jpg" },
  { name: "Baddow Park",    img: "https://img.youtube.com/vi/SrKZJHooNzw/maxresdefault.jpg" },
  { name: "High House",     img: "https://img.youtube.com/vi/tSAyeoBfnOk/maxresdefault.jpg" },
  { name: "Leez Priory",    img: "https://img.youtube.com/vi/Q8GecesihHw/maxresdefault.jpg" },
  { name: "Gosfield Hall",  img: "https://img.youtube.com/vi/AGtZI8qYfdo/maxresdefault.jpg" },
  { name: "Braxted Park",   img: "https://img.youtube.com/vi/3WiCAD4a83o/maxresdefault.jpg" },
  { name: "Friern Manor",   img: "https://img.youtube.com/vi/g8Sxnhb7Ics/maxresdefault.jpg" },
  { name: "Houchins",       img: "https://img.youtube.com/vi/8MDd61eoNqo/maxresdefault.jpg" },
  { name: "Mulberry House", img: "https://img.youtube.com/vi/Dqwuvg89XQ4/maxresdefault.jpg" },
  { name: "Apton Hall",     img: "https://img.youtube.com/vi/hbHdSgHfauE/maxresdefault.jpg" },
  { name: "The Lawn",       img: "https://img.youtube.com/vi/qlj7wa2kvvE/maxresdefault.jpg" }
];

export const PACKAGES = [
  {
    badge: "COMPLETE PACKAGE",
    title: "The Wedding Video & Photo Collection",
    desc: "Full day video + photo, one team, no stress. Two videographers and one photographer covering everything.",
    price: "From \u00a33,000",
    monthly: "or from \u00a3250/mo",
    bullets: [
      "Two videographers and one photographer",
      "Full day from bridal prep to first dance",
      "20 to 30 minute cinematic film",
      "Full ceremony edit (multi-camera)",
      "Full speeches edit (multi-camera)",
      "Cake cutting and first dance edits",
      "Drone footage (weather permitting)",
      "3 to 4 minute sneak peek within 72 hours",
      "30 to 40 sneak peek photos within a week",
      "Online gallery with 500+ edited photos",
      "Private online delivery. No hidden charges."
    ],
    featured: false
  },
  {
    badge: "MOST POPULAR",
    title: "The Wedding Video Collection",
    desc: "The one most couples go for. Two videographers, full day, cinematic film, plus all the individual edits.",
    price: "From \u00a32,295",
    monthly: "or from \u00a3191/mo",
    bullets: [
      "Two videographers all day",
      "Full day from bridal prep to first dance",
      "20 to 30 minute cinematic film",
      "Full ceremony edit (multi-camera)",
      "Full speeches edit (multi-camera)",
      "Cake cutting and first dance edits",
      "Drone footage (weather permitting)",
      "3 to 4 minute sneak peek within 72 hours",
      "Extras (singing waiters etc.) included",
      "Private online delivery. No hidden charges."
    ],
    featured: true
  },
  {
    badge: "",
    title: "Photo & Highlight Video",
    desc: "Photography plus a highlight film. One videographer and one photographer, up to 8 hours.",
    price: "From \u00a32,000",
    monthly: "or from \u00a3166/mo",
    bullets: [
      "One videographer and one photographer",
      "Up to 8 hours coverage",
      "10 to 15 minute highlight film",
      "Full ceremony and speeches edits",
      "300 to 500 professionally edited photos",
      "Private online delivery. No hidden charges."
    ],
    featured: false
  },
  {
    badge: "",
    title: "The Photo Collection",
    desc: "Just photography. One experienced photographer, full day or up to 8 hours.",
    price: "From \u00a31,500",
    monthly: "or from \u00a3125/mo",
    bullets: [
      "One experienced photographer",
      "Up to 8 hours coverage",
      "Online gallery with 500+ edited photos",
      "30 to 40 sneak peek photos within a week",
      "Private online delivery. No hidden charges."
    ],
    featured: false
  }
];

export const TESTIMONIALS = [
  {
    quote: "I would give the team more than 5 stars if I could. I 1000% recommend. When discussing with my now husband the day after the wedding we both said having the team there was more like 3 additional friends as wedding guests.",
    couple: "Michelle & Ken",
    date: "May 2026",
    source: "Verified on Bridebook",
    sourceUrl: "https://bridebook.com/uk/wedding-videographers/wedding-video-essex-wickford-essex-csNg0Nqz78"
  },
  {
    quote: "Me and my partner are both really camera awkward and it honestly felt like just having more friends at the wedding than it did a photographer and videographer. The team are so professional and put us totally at ease.",
    couple: "Michelle",
    date: "March 2026",
    source: "Verified on Hitched",
    sourceUrl: "https://www.hitched.co.uk/wedding-videographers/wedding-video-essex-films-&-photos_272043.htm"
  },
  {
    quote: "We hired Alex and his team for our wedding and I couldn't be more happy that we did. The service was perfect from start to finish. Complete professionalism but with a personal touch.",
    couple: "Stephen",
    date: "May 2026",
    source: "Verified on Hitched",
    sourceUrl: "https://www.hitched.co.uk/wedding-videographers/wedding-video-essex-films-&-photos_272043.htm"
  },
  {
    quote: "We honestly couldn't have asked for a better team to capture our special day. From start to finish, they were absolutely incredible. Professional, friendly, and so easy to work with.",
    couple: "Matthew",
    date: "April 2026",
    source: "Verified on Hitched",
    sourceUrl: "https://www.hitched.co.uk/wedding-videographers/wedding-video-essex-films-&-photos_272043.htm"
  },
  {
    quote: "We are yet to receive our final photos and videos but we received sneak peeks within a few days after the wedding. We opted for photo and video, and the team were unreal on the day.",
    couple: "Paige",
    date: "March 2026",
    source: "Verified on Hitched",
    sourceUrl: "https://www.hitched.co.uk/wedding-videographers/wedding-video-essex-films-&-photos_272043.htm"
  },
  {
    quote: "Excellent company and genuinely lovely guys. They know what they are doing and do it well. Couldn't fault a single thing about how they captured our wedding day.",
    couple: "Chris",
    date: "2026",
    source: "Verified on Hitched",
    sourceUrl: "https://www.hitched.co.uk/wedding-videographers/wedding-video-essex-films-&-photos_272043.htm"
  }
];

export const REVIEW_META = {
  rating: "5.0",
  count: "401",
  sources: "Hitched, Google, Facebook & Bridebook",
  reviewsUrl: "https://weddingvideoessexreviews.co.uk/"
};

export const BTS = [
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/x688lp10_7fcf9bde-226f-46a2-8ad1-72631bf5d44e.jpeg", caption: "Capturing the couple in the walled garden. Spring weddings in Essex are something else." },
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/1bd4nto7_536a87c3-d217-4dbd-9171-4b424e7bc63c.jpeg", caption: "Photographer and videographer working together under the festoon lights." },
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/qvohih3a_68bf6f06-bd19-450a-afb2-11eee303d2fa.jpeg", caption: "Golden hour on a country lane. These are the moments we live for." },
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/2veqyfgu_12f45291-c95d-4ce0-93a4-7b7945308abe.jpeg", caption: "Two cameras, one frame. Shooting through the lion gates." },
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/pveejrjl_B277DC91-581A-4E1E-920E-E4A0E6201272.jpeg", caption: "Inside the manor hallway. Side by side, never in each other's way." },
  { img: "https://essex.weddingvideo.co.uk/images/IMG_1569.jpg", caption: "Setting up the shot before the first look. Every angle matters." },
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/ssb395rm_b14a407c-9290-4bb7-b11d-628b1afe5c78.jpeg", caption: "Behind the lens on a beautiful Essex summer wedding." },
  { img: "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/hs9neeqa_0a6a5f9f-7ac3-46ea-b486-ecba04622523.jpeg", caption: "Working the room during the speeches. These reactions are everything." }
];

export const CONTACT_BG = "https://customer-assets.emergentagent.com/job_essex-wedding-films/artifacts/pveejrjl_B277DC91-581A-4E1E-920E-E4A0E6201272.jpeg";

export const FAQS = [
  { q: "How much does a wedding videographer cost in Essex?", a: "Most wedding videographers in Essex sit between \u00a31,000 and \u00a33,000 depending on coverage, number of videographers, and what you actually get. Our most popular package starts from \u00a32,295 and includes two videographers, full day coverage, a cinematic film, and all the edits. Combined photo and video packages start from \u00a33,000. Everything\u2019s digital and there are no hidden charges." },
  { q: "How much does wedding photography cost in Essex?", a: "Wedding photography in Essex usually ranges from \u00a3800 to \u00a32,000 depending on coverage and experience. Our dedicated photography package starts from \u00a31,500 for a full day with 500+ edited photos. Combined photo and video packages start from \u00a32,000 and the two will actually match in style." },
  { q: "What\u2019s in a wedding video package?", a: "A standard Vow & Video Essex package gives you two videographers for full day coverage from bridal prep to first dance. You get a 20 to 30 minute cinematic film, a 3 to 4 minute highlight reel within 72 hours, full edits of the ceremony, speeches, cake cutting, and first dance, plus drone footage where the venue and weather allow. All delivered digitally through a private online gallery." },
  { q: "Is a wedding videographer actually worth it?", a: "Honestly? Yes. Most couples who skip it say it\u2019s their biggest wedding regret. Photos are amazing but they can\u2019t capture the sound of your vows, the laughter during the speeches, or the moment you first see each other. A wedding film lets you relive the whole day, not just glimpses of it." },
  { q: "Do you really need both a photographer and videographer?", a: "They do very different things, and together they give you the full picture. Photos give you those frozen moments to frame on the wall. Video gives you everything in between. The vows in your own voices, the tears during the speeches, the energy on the dancefloor. Booking both with one team means no awkward coordination and a style that matches." },
  { q: "How long until we get our wedding video back?", a: "You\u2019ll get a 3 to 4 minute sneak peek highlight film within 72 hours of your wedding. Your full 20 to 30 minute cinematic film and all the additional edits land within 12 to 16 weeks. Sneak peek photos come back within a week." },
  { q: "How long is the final wedding film?", a: "Your main film is usually 20 to 30 minutes. A proper story-led edit that captures the full arc of your day. You also get a 3 to 4 minute highlight, plus separate full-length edits of your ceremony, speeches, first dance, and cake cutting." },
  { q: "Do you travel outside Essex?", a: "Yes. We\u2019re based in Wickford, but we regularly cover weddings across London, Kent, and the wider South East. We also travel further afield for destination weddings. No additional travel charges for venues within Essex." },
  { q: "Can we customise packages?", a: "Of course. Every package can be tweaked. Whether you need extended coverage, an extra videographer, or something specific, we\u2019ll build a package around your day." },
  { q: "How far in advance should we book?", a: "12 to 18 months is the sweet spot, especially for Saturday weddings between May and September. We film over 100 weddings a year and the calendar fills up fast. We only take a limited number of bookings per weekend." }
];
